import { useClientConfig } from "@/contexts/ClientConfigContext";

type LogoVariant = "menu" | "login" | "nf" | "background" | "default";

type Props = {
  variant?: LogoVariant;
  className?: string;
  alt?: string;
};

export function ClientLogo({ variant = "default", className, alt }: Props) {
  const { config } = useClientConfig();
  const src =
    variant === "menu"
      ? config.menu_logo_url
      : variant === "login"
        ? config.login_logo_url
        : variant === "nf"
          ? config.nf_logo_url
          : variant === "background"
            ? config.background_logo_url
            : config.logo_url;
  const label = alt ?? config.fantasy_name ?? config.name ?? "GrandSystem";

  return <img src={src} alt={label} className={className} />;
}
